import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { expVal } from '@atlassian/jira-feature-experiments';
import { ActionMenuItem } from './ActionMenuItem.tsx';

/**
 * We only intend to render the contents of this component when
 * the experiment 'jira_efa_for_cmp_m2_experiment' is enabled.
 *
 * This is a temporary workaround so we can roll out the first phase of EFA for CMP.
 *
 * The second phase will be to replace the page at the 'legacy-project-settings-fields'
 * URL with a new page served by AFM SPA. Once rolled out, this code can then be removed.
 */
export const LegacyProjectFieldsPageMountEfaOptInMenuItem = () => {
	const [portal, setPortal] = useState<React.ReactPortal | null>(null);

	// Apply useEffect() to avoid SSR + querying page for every render
	useEffect(() => {
		if (!expVal('jira_efa_for_cmp_m2_experiment', 'isEnabled', false)) {
			return;
		}
		if (!globalThis?.document?.querySelector) {
			return;
		}

		const linkElement = globalThis.document.querySelector<HTMLElement>(
			'#project-config-fields-scheme-change',
		);
		const projectId = linkElement?.dataset.id;
		const rootElement = linkElement?.parentElement; // from <a> to <li> in menu

		if (!rootElement || !projectId) {
			// eslint-disable-next-line no-console
			console.warn(
				'LegacyProjectFieldsPageMountEfaOptInMenuItem: No root element or project ID found.',
			);
			return;
		}

		// Empty existing contents from legacy page template
		rootElement.replaceChildren('');

		// Restore focus element
		const focusElement =
			globalThis.document.querySelector<HTMLElement>('#project-config-tab-actions') ?? undefined;

		// eslint-disable-next-line react-you-might-not-need-an-effect/no-initialize-state
		setPortal(
			createPortal(
				<ActionMenuItem projectId={projectId} restoreFocusElement={focusElement} />,
				rootElement,
				projectId,
			),
		);
	}, []);

	// Hook React into the mount point inside the menu.
	// This will replace the legacy menu <li> item (a link to another page)
	// with our own React rendered component which opens a modal.
	return portal;
};
